"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AutoModeFilledIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("circle", { cx: "16.468", cy: "8.605", r: "1.42" }),
        react_1.default.createElement("circle", { cx: "7.904", cy: "15.254", r: "1.42" }),
        react_1.default.createElement("path", { d: "M19.7.024H4.3A4.279,4.279,0,0,0,.024,4.3V19.7A4.28,4.28,0,0,0,4.3,23.976H19.7A4.28,4.28,0,0,0,23.976,19.7V4.3A4.279,4.279,0,0,0,19.7.024ZM8.669,18.09v1.967H7.139V18.09a2.933,2.933,0,0,1,0-5.672V3.8h1.53v8.615a2.933,2.933,0,0,1,0,5.672Zm8.564-6.649v8.616H15.7V11.441a2.933,2.933,0,0,1,0-5.671V3.8h1.531V5.77a2.933,2.933,0,0,1,0,5.671Z" })));
}
exports.default = AutoModeFilledIcon;
